import { render, staticRenderFns } from "./PhotoBasedSectionDysfunction.vue?vue&type=template&id=55ab171e&scoped=true"
import script from "./PhotoBasedSectionDysfunction.vue?vue&type=script&lang=js"
export * from "./PhotoBasedSectionDysfunction.vue?vue&type=script&lang=js"
import style0 from "./PhotoBasedSectionDysfunction.vue?vue&type=style&index=0&id=55ab171e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab171e",
  null
  
)

export default component.exports